import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'

class AdminLocations extends Component {
  render () {
    const { children, admin, dropdownLinks } = this.props
    return (
      <div>
        {children &&
          React.cloneElement(children, {
            admin,
            dropdownLinks
          })}
      </div>
    )
  }
}

AdminLocations.propTypes = {
  children: PropTypes.node,
  t: PropTypes.func,
  router: PropTypes.object,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin' ], { wait: true })(AdminLocations)



// WEBPACK FOOTER //
// ./src/pages/AdminLocations/index.js